import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class CustomPaginatorIntlService extends MatPaginatorIntl implements OnDestroy {
    private readonly subscription = new Subscription();

    constructor(transloco: TranslocoService) {
        super();

        const itemsPerPage$ = transloco.selectTranslate('paginator.itemsPerPage').pipe(distinctUntilChanged());
        const nextPage$ = transloco.selectTranslate('paginator.nextPage').pipe(distinctUntilChanged());
        const prevPage$ = transloco.selectTranslate('paginator.previousPage').pipe(distinctUntilChanged());
        const firstPage$ = transloco.selectTranslate('paginator.firstPage').pipe(distinctUntilChanged());
        const lastPage$ = transloco.selectTranslate('paginator.lastPage').pipe(distinctUntilChanged());

        this.subscription.add(
            combineLatest([itemsPerPage$, nextPage$, prevPage$, firstPage$, lastPage$]).subscribe(
                ([items, next, prev, first, last]) => {
                    this.itemsPerPageLabel = items;
                    this.nextPageLabel = next;
                    this.previousPageLabel = prev;
                    this.firstPageLabel = first;
                    this.lastPageLabel = last;
                    this.changes.next();
                }
            )
        );

        this.getRangeLabel = (page: number, size: number, total: number) => {
            if (!total || !size) {
                return transloco.translate('paginator.range.empty');
            }
            const start = page * size + 1;
            const end = Math.min(total, (page + 1) * size);
            return transloco.translate('paginator.range.showing', { start, end, total });
        };
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
